namespace GeniuzPOS.Lookups {
    export interface LookupIcStockSetAssemblePostedunuseRow {
        SysDocNo?: string;
        Name?: string;
    }

    export namespace LookupIcStockSetAssemblePostedunuseRow {
        export const idProperty = 'SysDocNo';
        export const nameProperty = 'Name';
        export const localTextPrefix = 'Lookups.LookupIcStockSetAssemblePostedunuse';
        export const lookupKey = 'Lookups.LookupIcStockSetAssemblePostedunuse';

        export function getLookup(): Q.Lookup<LookupIcStockSetAssemblePostedunuseRow> {
            return Q.getLookup<LookupIcStockSetAssemblePostedunuseRow>('Lookups.LookupIcStockSetAssemblePostedunuse');
        }
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            SysDocNo = "SysDocNo",
            Name = "Name"
        }
    }
}
